export default "__VITE_ASSET__6185851b__"